<template>
  <div class="ly1" style="position:relative" v-show="contentShow">
    <div class="noDateShow" v-if="noDateShow && !projectCheck">暂无数据</div> 
    <!-- <div class="colorImg"></div> -->
    <RollLegend class="rollLegend" fontColor="black" legendType="1" @childExam="getRnExam"></RollLegend>
    <LeftList :data="leftData" :keyMap="keyMap" />
    <div class="ly1-right">
      <heatMap v-if="!rnImageUrl"  @childLine="getRnView" :chartOption="chartOption" :contentShow="contentShow"/>
      <div v-if="rnImageUrl" class="imgCon">
        <!-- <el-button type="primary" class="checkDetail" @click="showDetail">查看详情</el-button> -->
        <el-image 
          style="width: 100%; height: 97%"
          :src="rnImageUrl" 
          fit="scale-down"
          @load="getRnImg"
          :preview-src-list="srcList">
          <div slot="error" class="image-slot">
            暂无数据
          </div>
        </el-image>
      </div>
    </div>
    <el-dialog width="1600px" custom-class="mapdialog" title="碾压遍数详情" :visible.sync="dialogMapVisible">
      <heatMap ref="heatmap" v-if="dialogMapVisible" :chartOption="chartOption" :contentShow="false"/>
    </el-dialog>
  </div>
</template>

<script>
import {unique,compress} from "../../../../utils/commons";
import LeftList from "../../../../components/layout/leftList";
// import Rolling from "../../../../components/chart/rolling";
import heatMap from "../../../../components/chart/heatMap";
import RollLegend from "../rollLegend";
// import ChartLine from "../../../../components/chart/line";
// import GridLayout from "../../../../components/layout/grid";
export default {
  data() {
    return {
      leftData: {},
      chartOption: {},
      keyMap: {
        max: ["最大遍数"],
        min: ["最小遍数"],
        average: ["平均遍数"],
        standardDiff: ["标准差"],
        passRate: ["合格率"],
        overRate: ["过压率"],
        lackRate: ["欠压率"],
      },
      contentShow: true,
      noDateShow: false,
      nullDate:false,
      // rollingTimesDown:false,
      getRn_view:'',
      dialogMapVisible:false,
      srcList:[]
    };
  },
  props:{
    rollingTimesData:{
      type: Object,
      default: function(){
        return {}
      }
    },
    activeIndex1Code: {
      type: Number,
      default: function () {
        return 9;
      },
    },
    workId: {
      type: Number,
      default: function () {
        return 0;
      },
    },
    projectCheck: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    rnImageUrl:{
      type: String,
      default: function(){
        return ''
      }
    }
  }, 
  watch:{
    rollingTimesData:function(newValue){
      console.log(newValue,'newValue')
      if(newValue == null){
        this.noDateShow = true
        this.getData(newValue);
      }
      else if(newValue.data==null||newValue.data.length == 0){
        this.noDateShow = true
        this.getData(newValue);
      }else{
        this.getData(newValue);
        this.noDateShow = false
      }
      
    },
    rnImageUrl(newV){
      this.srcList=[newV]
    },
    activeIndex1Code: {
      handler(newVal) {
        // console.log(newVal);
        if(newVal == 0){
          this.contentShow = true
        }else{
          this.contentShow = false
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  computed: {
    // workId() {
    //   return this.$store.getters["quality/activeWorkId"];
    // },
  },
  created() {},
  mounted() {
    // console.log(this.rollingTimesData,'this.rollingTimesData')
  },
  beforeDestroy(){
    this.$store.commit("setRn_view")
    this.$store.commit("setRn_exam")
  },
  methods: {
    showDetail(){
      this.dialogMapVisible=true
      let oriChartOption=JSON.parse(JSON.stringify(this.chartOption))
      this.chartOption={}
      setTimeout(()=>{
        this.chartOption=oriChartOption
      },500)
    },
    getRnView(e){
      console.log('接受setRn_view',e,this.workId)
      this.$store.commit("setRn_view",{content:e,workId:this.workId})
      this.$emit('heartMapDown',true)
      // this.rollingTimesDown=true
      this.getRn_view=e.src
    },
    getRnImg(){
      var c = document.createElement("canvas");
      var cxt=c.getContext("2d");
      var img=new Image();
      img.setAttribute("crossOrigin",'Anonymous');
      img.src=this.rnImageUrl
      let that=this
      img.onload=function(){
          c.width = this.width;
          c.height = this.height;
          cxt.drawImage(img, 0, 0, this.width, this.height) // 在canvas上绘制图片
          var dataURL = compress(img,this.width,this.height,0.8);
          var newImg = new Image();
          newImg.src=dataURL
          that.$store.commit("setRn_view",{content:newImg,workId:that.workId})
          setTimeout(()=>{
            console.log(that.$store.state.rn_view,that.$store.state.rn_exam)
          },500)
      }
    },
    getRnExam(e) {
      console.log('接受setRn_exam',e,this.workId)
      this.$store.commit("setRn_exam", e);
      if(!JSON.parse(localStorage.getItem("setRn_exam"))){
        localStorage.setItem("setRn_exam", JSON.stringify(e.src))
      }
    },
    getData(res) {
      if(res==null){
        res={}
        this.nullDate=true
      }
      res.average = res.average==undefined?null:res.average.toFixed(2);
      res.standardDiff = res.standardDiff==undefined?null:res.standardDiff.toFixed(2);
      res.passRate = res.passRate==undefined?null:(res.passRate * 100).toFixed(2) + "%";
      res.overRate = res.overRate==undefined?null:(res.overRate * 100).toFixed(2) + "%";
      res.lackRate = res.lackRate==undefined?null:(res.lackRate * 100).toFixed(2) + "%";
      res.max = res.max==undefined?null:res.max;
      res.min = res.min==undefined?null:res.min;
      this.leftData = res;
      res.data=res.data?res.data:[]
      let xAxisObj = {}
      var xAxisData = res.data.map((item) => item[0]);
      var yAxisData = this.$store.state.roadWidth;
      console.log(yAxisData)
      xAxisData = unique(xAxisData)
      for(let i=0;i<xAxisData.length;i++){
        xAxisObj[xAxisData[i]] = i
      }
      let data = [];
      const dataMap = {};
      res.data.map((item) => {
        const y = Math.floor(Math.random() * 6);
        dataMap[`${item[0]}_${y}`] = Math.ceil(Math.random() * 20);
      });
      let code = this.$store.state.deviationUnit
      for(let i=0;i<res.data.length;i++){
        let arr = [xAxisObj[res.data[i][0]],res.data[i][1]*10/(code*10),res.data[i][2]]
        data.push(arr)
      }
      console.log(data)
      // console.log(data,"rollingTimes")

      
      // const colorBox =  this.$store.state.rollNumColorArr.reverse();
      const colorBox =  JSON.parse(JSON.stringify(this.$store.state.rollNumColorArr)).reverse();
      
      let colorList = this.$store.state.rollNumColor;
      let keys = Object.keys(colorList);
      let setArr = []
      for(let i=0;i<keys.length;i++){
        setArr.push({
          min: keys[i]*1,
          max: keys[i]*1
        })
      }
      setArr[setArr.length-1].max = 200
      if(this.nullDate){
        this.chartOption = {
          visualMap: {
            type: "piecewise",
            min: 0,
            max: 100,
            calculable: true,
            realtime: false,
            orient: "horizontal",
            left: "center",
            bottom: "15%",
            show: false,
            pieces:[],
            color: [],
          },
          xAxis: {
            type: "category",
            data: [],
            splitArea: {
              show: true,
            },
            splitLine:{
              show:false
            },
            axisLabel:{
              lineStyle:{
                color: '#878787'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#878787'
              }
            },
            axisTick:{
              show:false
            }
          },
          yAxis: [{
            type: "category",
            data: [],
            splitArea: {
              show: true,
            },
            splitLine:{
              show:false
            },
            axisLabel:{
              lineStyle:{
                color: '#878787'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#878787'
              }
            },
            axisTick:{
              show:false
            }
          }
          ],
          series: [
            {
              name: "遍数",
              type: "heatmap",
              data: [],
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
          dataZoom: [{
              type: 'slider',
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: '10%',
              height: 10,
              handleStyle:{
                borderWidth: 2
              },
              bottom:'10%'
          }, {
              type: 'inside',
              xAxisIndex: [0],
          }, {
              type: 'slider',
              yAxisIndex: [0],
              show: false,
              zoomLock: true
          }]
        };
      }else{
        this.chartOption = {
          visualMap: {
            type: "piecewise",
            min: 0,
            max: 100,
            calculable: true,
            realtime: false,
            orient: "horizontal",
            left: "center",
            bottom: "15%",
            show: false,
            pieces:setArr,
            color: colorBox,
          },
          xAxis: {
            type: "category",
            data: xAxisData,
            splitArea: {
              show: true,
            },
            splitLine:{
              show:false
            },
            axisLabel:{
              lineStyle:{
                color: '#878787'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#878787'
              }
            },
            axisTick:{
              show:false
            }
          },
          yAxis: [{
            type: "category",
            data: yAxisData,
            splitArea: {
              show: true,
            },
            splitLine:{
              show:false
            },
            axisLabel:{
              lineStyle:{
                color: '#878787'
              }
            },
            axisLine:{
              lineStyle:{
                color:'#878787'
              }
            },
            axisTick:{
              show:false
            }
          }
          ],
          series: [
            {
              name: "遍数",
              type: "heatmap",
              data: data,
              label: {
                show: false,
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
            // {
            //   type: 'line',
            //   data: [['K00+007.51', '11'], ['K00+117', '11'], ['K00+168.3', '2'],['K00+007.51', '2'],['K00+007.51', '11']],
            //   lineStyle:{
            //     color:['#ff0'],
            //     width:2
            //   }
              
            // }
          ],
          dataZoom: [{
              type: 'slider',
              show: true,
              realtime: true,
              start: 0,
              end: 100,
              handleSize: '10%',
              height: 10,
              handleStyle:{
                borderWidth: 2
              },
              bottom:'10%'
          }, {
              type: 'inside',
              xAxisIndex: [0],
          }, {
              type: 'slider',
              yAxisIndex: [0],
              show: false,
              zoomLock: true
          }]
        };
      }
      console.log(this.chartOption)
    },
    
  },
  components: {
    LeftList,
    // Rolling,
    heatMap,
    // ChartLine,
    // GridLayout,
    RollLegend
  },
};
</script>

<style lang="scss" scoped="">
.ly1{
  height: 100%;
}
.noDateShow{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba($color: #ffffff, $alpha: 0.7);
  z-index: 100;
  text-align: center;
  line-height: 640px;
}
.colorImg{
  position: absolute;
  border: 1px solid #e1e1e1;
  height: 121px;
  width: 360px;
  bottom: 50px;
  left: 0px;
  background-image: url('../../../../images/all/rollNum.png');
  background-size: 99.8% 99.5%;
}

.rollLegend{
  position: absolute;
  bottom: 50px;
  left: 0px;
}
.imgCon{
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: relative;
  .checkDetail{
    width: 80px;
    height: 30px;
    // line-height: 30px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 99;
  }
  img{
    width: 100%;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.mapdialog{
  width: 1520px !important;
  .el-dialog__header{
    width: 1515px !important;
  }
  .el-dialog__body{
    width: 1515px !important;
    height: 520px !important;
  }
}
</style>